import { Configuration, PopupRequest } from "@azure/msal-browser";

export const msalConfig: Configuration = {
  auth: {
    clientId: process.env.REACT_APP_MS_CLIENT_ID || "",
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_MS_TENANT_ID || ""}`,
    // Must be registered as SPA redirect URI in Azure AD
    redirectUri:
      process.env.REACT_APP_MS_REDIRECT_URI || window.location.origin,
    // Na terugkeer van Microsoft blijven we op de redirectUri (app-root); de
    // router stuurt ingelogde gebruikers zelf naar het juiste dashboard.
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: "localStorage", // Use localStorage for better multi-tab support
    storeAuthStateInCookie: false,
  },
};

export const loginRequest: PopupRequest = {
  scopes: ["openid", "profile", "email"],
};
